import React, { useEffect } from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { setModal } from '../../redux-root/actions';
import Text from '../Text';
import Button from '../Button';
import Checkbox from '../Checkbox';

import styles from './index.module.css';

import errorIcon from '../../assets/icons/error/alert.svg';
import castIcon from "../../assets/icons/logo/ui_logo_cast_1.svg";

function Modal(props) {
  const { modal, tvMode } = props;

  useEffect(() => {
    if (tvMode) {
      document.addEventListener('keydown', changeFocus);
      document.getElementById('modal-button').focus();
    }

    return () => {
      if (tvMode) {
        document.removeEventListener("keydown", changeFocus);
      }
    };
  }, []);

  const modalClick = () => {
    if (modal.onClick) {
      modal.onClick();
    }

    props.setModal(null);
  }

  const changeFocus = (e) => {
    if (e.keyCode === 10009 || e.keyCode === 461) { // BACK KEY TIZEN & LG
      if (modal.onBack) {
        modal.onBack();
      }

      props.setModal(null);
    }
  }

  let buttonText = 'Okay';

  if (modal.buttonText) {
    buttonText = modal.buttonText;
  }

  return (
    <div className={styles['wrapper']}>
      <div className={styles['bg']} onClick={() => props.setModal(null)} />
      <div className={styles['container']}>
        {
          modal.copyValue || modal.showLogo ?
            <img src={castIcon} className={styles['logo']} alt="modal-icon" />
            :
            modal.image ?
              <img src={modal.image} alt="modal-icon" />
              :
              <img src={errorIcon} alt="modal-icon" />
        }

        <Text type="h4" className={styles['title']}>
          {modal.title ? modal.title : ''}
        </Text>

        <Text type="l32" className={styles['description']}>
          {modal.description ? modal.description : ''}
        </Text>

        {
          modal.copyValue ?
            <div className={styles['copy-container']}>
              <Text type="l32">
                {modal.copyValue}
              </Text>
              
              <div onClick={() => navigator.clipboard.writeText(modal.copyValue)}>
                <Text type="l32" className={styles['copy-button']}>
                  Copy
                </Text>
              </div>
            </div>
            :
            ""
        }

        <div className={styles['button-container']}>
          <Button
            text={buttonText}
            id="modal-button"
            textType="lb28"
            style={{ minWidth: '240px' }}
            onClick={modalClick}
          />

          {
            modal.cancelButtonText ?
              <Button
                text={modal.cancelButtonText}
                id="cancel-button"
                textType="lb28"
                style={{ minWidth: '240px' }}
                onClick={() => {
                  props.setModal(null)
                  modal.onCancel();
                }}
              />
              :
              ""
          }
        </div>

        {
          modal.checkboxObj ?
            <Checkbox
              text={modal.checkboxObj.title}
              className={styles['checkbox']}
              onClick={modal.checkboxObj.checked}
            />
            :
            ""
        }
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  modal: state.app.modal,
  tvMode: state.app.tvMode
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setModal
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Modal);
